import { Injectable } from '@angular/core';
import { IAuthService } from '@app/auth/interfaces/auth-service.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';

/**
 * Generic mock implementation of IAuthService for testing purposes.
 * Can be used to test components that depend on auth services without
 * worrying about the specific provider (MSAL or Okta).
 */
@Injectable()
export class AuthServiceMock implements IAuthService {
  loginSuccess$: Observable<void>;

  private readonly loginSuccessSubject$ = new BehaviorSubject<boolean>(false);

  constructor() {
    this.loginSuccess$ = this.loginSuccessSubject$.asObservable().pipe(
      filter(Boolean),
      map(() => undefined),
      first()
    );
  }

  init(): void {
    // Mock implementation - simulate successful initialization
    setTimeout(() => {
      this.loginSuccessSubject$.next(true);
    }, 100);
  }

  loginRedirect(): void {
    // Mock implementation - no actual redirect
    console.log('Mock: loginRedirect called');
  }

  logout(): void {
    // Mock implementation - no actual logout
    console.log('Mock: logout called');
    this.loginSuccessSubject$.next(false);
  }

  handleAfterLoggedIn(): void {
    // Mock implementation - no actual handling
    console.log('Mock: handleAfterLoggedIn called');
  }

  /**
   * Helper method for tests to simulate successful login
   */
  simulateSuccessfulLogin(): void {
    this.loginSuccessSubject$.next(true);
  }

  /**
   * Helper method for tests to check if login was attempted
   */
  isLoggedIn(): boolean {
    return this.loginSuccessSubject$.getValue();
  }
}
